import IMG1 from "../assets/gallery/IMG1.jpg"
import IMG2 from "../assets/gallery/IMG2.jpg"
import IMG3 from "../assets/gallery/IMG3.jpg"
import IMG4 from "../assets/gallery/IMG4.jpg"
import IMG5 from "../assets/gallery/IMG5.jpg"

export const Blogs = [
    {
        id:1,
        name:"My First team",
        tags:["react","gsap","styled-components"],
        date:"13 May, 2021",
        imgSrc:IMG5,
    },
    {
        id:2,
        name:"My First team",
        tags:["react","styled-components"],
        date:"5 July, 2021",
        imgSrc:IMG1,
    },
    {
        id:3,
        name:"My First team",
        tags:["react","react-lottie","styled-components"],
        date:"6 July, 2021",
        imgSrc:IMG2,
    },
    {
        id:4,
        name:"How to build a Fabulous Todo App using React, Redux and Framer-Motion",
        tags:["react","redux","framer-motion"],
        date:"26 May, 2021",
        imgSrc:IMG3,
    },
    {
        id:5,
        name:"What is Higher Order Component (HOC) in React JS?",
        tags:["react","reactJS","web-development"],
        date:"3 Feb, 2021",
        imgSrc:IMG4,
    },
    // {
    //     id:6,
    //     name:"How to implement Pagination Component in React from scratch",
    //     tags:["react","css"],
    //     date:"5 Jan, 2021",

    // },
   
    // {
    //     id:7,
    //     name:"What is Redux ? Simply Explained!",
    //     tags:["react","redux","javascript"],
    //     date:"16 May, 2021",
    // },
    // {
    //     id:8,
    //     name:"How to create Sidebar navigation menu in ReactJS with react router and framer-motion",
    //     tags:["react","framer-motion","styled-components"],
    //     date:"26 May, 2021",
    //     imgSrc:"https://res.cloudinary.com/practicaldev/image/fetch/s--rv4I8UwE--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/0a9h50milhlf1us6mn4a.png",
    // },
  
] 